import React, { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { 
  Snackbar, 
  Alert, 
  Button, 
  Box,
  Typography 
} from '@mui/material';
import { 
  Refresh as RefreshIcon,
  CloudDownload as UpdateIcon 
} from '@mui/icons-material';

const PWAUpdatePrompt = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log('SW Registered: ' + r);
    },
    onRegisterError(error) {
      console.log('SW registration error', error);
    },
  });

  useEffect(() => {
    if (needRefresh) {
      setUpdateAvailable(true);
    }
  }, [needRefresh]);

  const handleUpdate = () => {
    updateServiceWorker(true);
    setUpdateAvailable(false);
  };

  const handleClose = () => {
    setUpdateAvailable(false);
    setNeedRefresh(false);
  };

  if (offlineReady) {
    return (
      <Snackbar
        open={true}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={() => setOfflineReady(false)}
      >
        <Alert 
          severity="success" 
          onClose={() => setOfflineReady(false)}
          sx={{ alignItems: 'center' }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <UpdateIcon fontSize="small" />
            <Typography variant="body2">
              SeriesX is now available offline!
            </Typography>
          </Box>
        </Alert>
      </Snackbar>
    );
  }

  if (!updateAvailable) {
    return null;
  }

  return (
    <Snackbar
      open={updateAvailable}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={handleClose}
    >
      <Alert 
        severity="info" 
        onClose={handleClose}
        action={
          <Button 
            onClick={handleUpdate}
            startIcon={<RefreshIcon />}
            sx={{ 
              color: 'inherit',
              fontWeight: 600,
              textTransform: 'none'
            }}
          >
            Update
          </Button>
        }
        sx={{ 
          alignItems: 'center',
          '& .MuiAlert-message': {
            display: 'flex',
            alignItems: 'center'
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <UpdateIcon fontSize="small" />
          <Typography variant="body2">
            New version available! Click update to refresh.
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default PWAUpdatePrompt;